import React from "react";
import ReusableForm from "../../../common/ReusableForm";

import { Typography } from "@mui/material";

const fields = [
  {
    label: "Professor Domain",
    name: "professorDomain",
    id: "professorDomain",
    type: "text",
    required: true,
    errorKey: "professorDomain",
  },
  {
    label: "Student Domain",
    name: "studentDomain",
    id: "studentDomain",
    type: "text",
    required: true,
    errorKey: "studentDomain",
  },
];

const AddDomainsForm = ({
  handleSubmit,
  handleInputChange,
  data,
  formError,
  type,
  isApiLoading,
  handleCloseModal,
  isDisabled,
}) => {
  return (
    <>
      <Typography variant="h6" gutterBottom sx={{ marginBottom: 2 }}>
        {type === "add" ? "Add Domains" : "Edit Domains"}
      </Typography>
      <ReusableForm
        fields={fields}
        handleChange={handleInputChange}
        handleSubmit={handleSubmit}
        errors={formError}
        formData={data}
        isApiLoading={isApiLoading}
        handleCloseModal={handleCloseModal}
        isDisabled={isDisabled}
        type={type}
      />
    </>
  );
};

export default AddDomainsForm;
